import MARKETING_HERO_CONSTANTS from '../Constants/MarketingConstants';
import { AnalyticsService } from '@kfc-global/react-shared/analytics';
import events from '@kfc-global/react-shared/analytics/Register';
import { getDataLayer, filterMarketingData } from 'common/utilities/utils';
import { logEvent } from 'common/utilities/analyticsUtils';

const { VIDEO, VIDEO_COMP } = MARKETING_HERO_CONSTANTS;

/**
 *
 * @param {*} data - all carausel data - Array
 */
export const modifyData = (carousalContent = []) => {
  return carousalContent.map(item => {
    const {
      headline: smallText = '',
      subHeadline: largeText,
      altText: alt = '',
      showButton = '',
      buttonType: buttonText = '',
      onClick: linkTo,
      name,
      noteLine,
      backgroundImageType,
      background,
      textColor = '',
      externalUrl = '',
      id: promotion_id = '',
      categoryLinkItem,
      pdpLinkItem,
      categoryName,
    } = item.fields;
    const { fields: analyticsData = {} } = item.fields.analyticsData || {};
    const { url: desktopSrc, contentType } =
      item?.fields?.bannerType !== VIDEO
        ? item?.fields?.desktopImage?.fields?.file
        : item?.fields?.videoFile?.fields?.mp4File?.fields?.file;
    const { url: mobileSrc } =
      item?.fields?.bannerType !== VIDEO
        ? item?.fields?.mobileImage && item?.fields?.mobileImage?.fields && item?.fields?.mobileImage?.fields?.file
        : item?.fields?.videoFile?.fields?.mp4File?.fields?.file;
    const bannerType = item?.fields?.bannerType;
    return {
      smallText,
      largeText,
      alt,
      desktopSrc,
      mobileSrc,
      buttonText,
      showButton,
      textColor,
      analyticsData,
      linkTo,
      name,
      noteLine,
      bannerType,
      contentType,
      backgroundImageType,
      background,
      externalUrl,
      promotion_id,
      categoryLinkItem,
      pdpLinkItem,
      categoryName,
    };
  });
};
/**
 *
 * @param {*} data - View Promotion on marketing hero load
 */
export const setMarketingAnalyticsOnLoad = async (data, currencyShortName) => {
  const dataObj = filterMarketingData(data, currencyShortName);
  const { ecommerceObject, itemsArray } = dataObj;
  let analyticsItems = [];
  analyticsItems.push({
    event: 'view_promotion',
    ecommerce: ecommerceObject,
    items: itemsArray,
  });
  logEvent('view_promotion', {
    data: analyticsItems[0],
  });
};

const fireOrderNowAnalyticsEvent = async () => {
  await AnalyticsService.registerEvent(
    events.orderNow.name,
    {
      '%event%': 'orderNow',
    },
    getDataLayer,
  );
};

/**
 *
 *  Order Button click analytics
 */
export const orderBtnAnalytics = async (data, ind) => {
  fireOrderNowAnalyticsEvent();
  const analyticsItems = [];
  analyticsItems.push(
    {
      event: 'homepageBannerCTA',
      bannerContent: data.item_name,
      bannerContentIndex: ind,
    },
    {
      event: 'select_promotion',
      ecommerce: {
        items: [
          {
            item_name: data.item_name,
            item_id: data.item_id,
            item_category: data.item_category,
            promotion_id: data.promotion_id,
            promotion_name: data.promotion_name,
            creative_name: data.creative_name,
            location_id: data.location_id,
            index: ind,
            price: data.price,
          },
        ],
      },
    },
  );
  await AnalyticsService.registerEvent(
    undefined,
    {
      data: analyticsItems[0],
    },
    getDataLayer,
  );
};

/**
 *
 *  Image click analytics
 */
export const clickImageAnalytics = async (data, ind, item, currencyShortName) => {
  const dataObj = filterMarketingData(item, currencyShortName);
  const { ecommerceObject, itemsArray } = dataObj;
  const analyticsItems = [];
  analyticsItems.push(
    {
      event: 'select_promotion',
      ecommerce: ecommerceObject,
      items: itemsArray,
    },
    {
      event: 'homepageBannerCTA',
      bannerContent: data.item_name,
      bannerContentIndex: ind,
    },
  );
  logEvent(
    events?.select_promotion?.name,
    {
      data: analyticsItems[0],
    },
    getDataLayer,
  );
};

const isDateBetween = (startDate, endDate) => {
  const currentDateMilliSec = new Date().getTime();
  const startDateMilliSec = new Date(startDate).getTime();
  const endDateMilliSec = new Date(endDate).getTime();
  if (currentDateMilliSec > startDateMilliSec && currentDateMilliSec < endDateMilliSec) {
    return true;
  }
  return false;
};

const isCurrentDayAvailable = daysArray => {
  const today = MARKETING_HERO_CONSTANTS.daysOfTheWeek[new Date().getDay()];
  return daysArray.find(day => day.toLowerCase() === today.toLowerCase());
};

const dispotionOrIncludeStoreCheck = (
  dispositionFromContentful,
  includedStores,
  disposition,
  storeId,
  storeName,
  summary,
) => {
  if (summary?.storeGroups?.length > 0 && includedStores?.length > 0) {
    const statusGroupByCheck = includedStores.filter(includeStore =>
      summary?.storeGroups.some(
        store =>
          includeStore?.fields?.storeGroupId === store?.id &&
          includeStore?.fields?.storeGroupName === store?.storeGroupName,
      ),
    );
    if (statusGroupByCheck.length > 0) {
      return true;
    } else {
      return (
        (dispositionFromContentful &&
          dispositionFromContentful.find(item => item?.toLowerCase() === disposition?.toLowerCase())) ||
        (includedStores &&
          includedStores?.find(store => store?.fields.storeId === storeId && store?.fields?.storeName === storeName))
      );
    }
  } else {
    return (
      (dispositionFromContentful &&
        dispositionFromContentful?.find(item => item?.toLowerCase() === disposition?.toLowerCase())) ||
      (includedStores &&
        includedStores?.find(store => store?.fields?.storeId === storeId && store?.fields?.storeName === storeName))
    );
  }
};

const dispositionIncludeSotreCheck = (
  dispositionFromContentful,
  includedStores,
  disposition,
  storeId,
  storeName,
  summary,
) => {
  if (summary?.storeGroups?.length > 0) {
    const statusGroupByCheck = includedStores.filter(includeStore =>
      summary?.storeGroups?.some(
        store =>
          includeStore?.fields?.storeGroupId === store?.id &&
          includeStore?.fields?.storeGroupName === store?.storeGroupName,
      ),
    );
    if (statusGroupByCheck.length > 0 && dispositionFromContentful?.length > 0) {
      const statusDispositionCheck = dispositionFromContentful.find(
        item => item?.toLowerCase() === disposition?.toLowerCase(),
      );
      if (statusDispositionCheck) {
        return true;
      }
    } else {
      return (
        dispositionFromContentful &&
        dispositionFromContentful.find(item => item?.toLowerCase() === disposition?.toLowerCase()) &&
        includedStores &&
        includedStores?.find(store => store?.fields.storeId === storeId && store?.fields?.storeName === storeName)
      );
    }
  } else {
    return (
      dispositionFromContentful &&
      dispositionFromContentful.find(item => item.toLowerCase() === disposition.toLowerCase()) &&
      includedStores &&
      includedStores.find(store => store.fields.storeId === storeId && store.fields.storeName === storeName)
    );
  }
};

/* istanbul ignore next */
export const isInAvailableStore = (
  dispositionFromContentful,
  includedStores,
  disposition,
  storeId,
  storeName,
  summary,
) => {
  // if both disposition and includedStores has no data (means empty array) or undefined
  if (
    dispositionFromContentful === undefined &&
    includedStores === undefined
    // ||
    // (dispositionFromContentful.length === 0 && includedStores.length === 0)
  ) {
    return true;
  }

  // both disposition and includedStores data are given
  /* istanbul ignore next */
  if (dispositionFromContentful?.length > 0 && includedStores?.length > 0) {
    return dispositionIncludeSotreCheck(
      dispositionFromContentful,
      includedStores,
      disposition,
      storeId,
      storeName,
      summary,
    );
  }

  // either of disposition or includedStores one of them is given
  /* istanbul ignore next */
  else {
    return dispotionOrIncludeStoreCheck(
      dispositionFromContentful,
      includedStores,
      disposition,
      storeId,
      storeName,
      summary,
    );
  }
};

export const getFilteredCarausalData = (carausalData, disposition, storeId, storeName, summary) => {
  let filteredWithDate = carausalData.filter(data => isDateBetween(data.fields.startDate, data.fields.endDate));
  let filteredWithDays = filteredWithDate.filter(data =>
    data.fields.applicableDays ? isCurrentDayAvailable(data.fields.applicableDays) : true,
  );
  return filteredWithDays.filter(data => {
    if (disposition === '' || storeId === '' || storeName === '') {
      // if user is non-localized
      if (
        (data.fields.disposition && data.fields.disposition.length > 0) ||
        (data.fields.includeTheseStoresOnly && data.fields.includeTheseStoresOnly.length > 0)
      ) {
        return false;
      }
      return true;
    }

    return isInAvailableStore(
      data.fields.disposition,
      data.fields.includeTheseStoresOnly,
      disposition,
      storeId,
      storeName,
      summary,
    );
  });
};

export const getVideoCompName = nameSuffix => {
  return VIDEO_COMP + (nameSuffix !== '' ? nameSuffix : '');
};

export const getVideoElementRef = nameSuffix => {
  return document.getElementById(getVideoCompName(nameSuffix));
};

export const extractAnalyticsData = params => ({
  analyticsData: params?.fields ?? {},
});
export const setAnalyticEventOnSingleBanner = (ecommerceObject, itemsArray) => {
  let analyticsItems = [];
  analyticsItems.push({
    event: 'view_promotion',
    ecommerce: ecommerceObject,
    items: itemsArray,
  });
  logEvent('view_promotion', {
    data: analyticsItems[0],
  });
};
